import BrickTitle from "@/components/landing/BrickTitle";

const HERO_IMG = "https://images.pexels.com/photos/4981806/pexels-photo-4981806.jpeg?auto=compress&w=1920";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] lg:min-h-[640px] flex items-center justify-center text-white overflow-hidden bg-[#12171B]"
    >
      <img
        src={HERO_IMG}
        alt="Will with a full tool belt, carefully leveling a wall"
        className="absolute inset-0 w-full h-full object-cover saturate-[1.05]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#12171B] via-[#12171B]/65 to-[#12171B]/45" />

      <div className="relative z-10 min-w-0 w-full max-w-4xl mx-auto px-4 sm:px-6 py-20 text-center mc-animate-enter">
        <span
          data-testid="hero-badge"
          className="inline-flex max-w-full items-center gap-2 px-3.5 py-1.5 rounded-full text-xs font-semibold bg-[#D4691E]/20 text-[#FFAE70] border border-[#D4691E]/40 mb-6 backdrop-blur-sm"
        >
          <span className="w-2 h-2 shrink-0 rounded-full bg-[#D4691E]" />
          EPA Universal Certified &bull; All-Trade Residential Specialist
        </span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.15]">
          <BrickTitle text="One Call Solves Everything" />
        </h1>
        <p className="text-lg sm:text-xl text-[#D8D2CA] max-w-2xl mx-auto mb-10 leading-relaxed font-normal">
          From structural welding and roof leaks to EPA-certified AC repair, custom carpentry, and 3D printing.
          Honest craftsmanship at a rate that beats local averages, delivered with complete respect for your property.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            data-testid="hero-quote-cta"
            className="w-full sm:w-auto px-8 py-4 rounded-lg bg-[#D4691E] hover:bg-[#A94E10] text-white font-bold text-base transition-colors shadow-lg shadow-[#D4691E]/30 text-center"
          >
            Get Instant Quote Estimate
          </a>
        </div>
        <p className="text-xs text-[#A39B92] mt-4">
          Direct response within 2 business hours &bull; No hidden service charges &bull; Serving all of South Louisiana
        </p>
      </div>
    </section>
  );
}
